import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Checkbox, Flex, Input, Label, Text, useColorMode } from 'theme-ui';
import { deleteActionHighlight, editActionHighlight } from '../../../store/actions/action.Highlighters';
import { getAllSubtask, getAllSubtaskSummary, getAllDuplicateSubtasks } from '../../../store/actions/project.action';
import editIcon from "../../../Components/assets/images/edit.svg";
import deleteIcon from "../../../Components/assets/images/Icon/delete.svg";

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdDeleteForever, MdDownloadDone, MdRateReview } from "react-icons/md";
import { DeletePopModule } from '../../DeletePopModule/DeletePopModule';
import { LuPenLine } from 'react-icons/lu';

export const ActionCard = ({ index, action, selectedHighlight, keys, actionObject, parentData, parentName, isOthersTab = false, isShowDeleteCheckbox = true, actionId, inputWidth = "33%", handleDeleteCheckboxChange, deleteIdList = [], parentId }: any) => {
  const dispatch = useDispatch();
  const [updateName, setUpdateName] = useState<string>();
  const [isDeleteModelOpen, setIsDeleteModelOpen] = useState<boolean>(false);
  const [deleteData, setDeleteData] = useState<string[]>([]);
  const [isEditing, setIsEditing] = useState<boolean>(true);
  const { _id, highlighterId } = parentData
  const [isDeleteChecked, setIsDeleteChecked] = useState<boolean[]>([]);

  // Local state for checkboxes to update UI instantly
  const [isCheckedThird, setIsCheckedThird] = useState<boolean>(action[keys?.third] || false);
  const [isCheckedFirst, setIsCheckedFirst] = useState<boolean>(action[keys?.first] || false);

  // Sync ref to always hold the latest values synchronously
  const checkboxValues = useRef({
    third: action[keys?.third] || false,
    first: action[keys?.first] || false,
  });

  const prevActionRef = useRef(action);

  useEffect(() => {
    if (action && keys) {
      if (prevActionRef.current?.[keys?.third] !== action[keys?.third]) {
        setIsCheckedThird(action[keys?.third] || false);
        checkboxValues.current.third = action[keys?.third] || false;
      }
      if (prevActionRef.current?.[keys?.first] !== action[keys?.first]) {
        setIsCheckedFirst(action[keys?.first] || false);
        checkboxValues.current.first = action[keys?.first] || false;
      }
    }
    prevActionRef.current = action;
  }, [action]);

  useEffect(() => {
    setIsDeleteChecked(new Array(action?.length).fill(false));
  }, [action.length]);

  const dispatchUpdate = () => {
    const payload = {
      name: action?.name,
      blockingTaskId: action?.blockingTaskId,
      ...actionObject,
      actionType: selectedHighlight,
      data: {
        [keys?.third]: checkboxValues.current.third,
        [keys?.first]: checkboxValues.current.first,
      }
    };
    dispatch(editActionHighlight(payload, actionId || parentData?._id, (res: { status?: number | string; data?: unknown }) => {
      if (res?.status === 200 || res?.status === "200" || res?.data) {
        if (actionObject && actionObject?.projectId && (actionObject?.stageId || actionObject?.stageDataId) && actionObject?.taskId) {
          dispatch(getAllSubtask(actionObject));
          dispatch(getAllSubtaskSummary(actionObject));
          if (actionObject?.taskId) {
            dispatch(getAllDuplicateSubtasks(actionObject.taskId));
          }
        }
      }
    }));
  };

  const handleThirdChange = (e: any) => {
    const val = e.target.checked;
    setIsCheckedThird(val);
    checkboxValues.current.third = val;
    dispatchUpdate();
  };

  const handleFirstChange = (e: any) => {
    const val = e.target.checked;
    setIsCheckedFirst(val);
    checkboxValues.current.first = val;
    dispatchUpdate();
  };

  const editActionHighlightName = () => {
    if (!updateName?.trim() || updateName === action?.name) return;

    const payload = {
      name: action?.name,
      ...actionObject,
      actionType: selectedHighlight,
      data: {
        name: updateName,
      }
    }
    dispatch(editActionHighlight(payload, actionId || parentData?._id, (res: { status?: number | string; data?: unknown }) => {
      if (res?.status === 200 || res?.status === "200" || res?.data) {
        if (actionObject && actionObject?.projectId && (actionObject?.stageId || actionObject?.stageDataId) && actionObject?.taskId) {
          dispatch(getAllSubtask(actionObject));
          dispatch(getAllSubtaskSummary(actionObject));
          if (actionObject?.taskId) {
            dispatch(getAllDuplicateSubtasks(actionObject.taskId));
          }
        }
      }
    }))
  }

  const deleteCheckAction = () => {
    const subtaskId = action?._id || deleteData;
    const parentId = actionId || parentData?._id;
    dispatch(deleteActionHighlight({ id: subtaskId }, parentId, (res: { status?: number | string; data?: unknown }) => {
      if (actionObject && actionObject?.projectId && (actionObject?.stageId || actionObject?.stageDataId) && actionObject?.taskId) {
        dispatch(getAllSubtask(actionObject));
        dispatch(getAllSubtaskSummary(actionObject));
        if (actionObject?.taskId) {
          dispatch(getAllDuplicateSubtasks(actionObject.taskId));
        }
      }
    }));
  }

  useEffect(() => {
    if (action?.name) {
      setUpdateName(action?.name)
    }
  }, [action?.name])

  const abbreviations: any = { Revision: "REV", Subtask: "SUB", "New Need Info Added": "NI", "Blocked By Trade": "BT" };
  const displayName = abbreviations[parentName] || parentName;
  const [colorMode] = useColorMode();
  const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";

  return (
    <Box sx={{ display: "grid", paddingLeft: "0.5rem", borderLeft: `2px solid ${selectedHighlight?.color}`, gap: "1rem", }} >
      <Flex sx={{ gap: "1rem", }}>
        <Flex sx={{
          background: modalHeader,
          paddingLeft: "12px",
          paddingRight: "20px",
          marginTop: "10px",
          borderRadius: "8px",
          paddingTop: "2px",
          gap: "10px",
          width: "100%",
          alignItems: "center",
          position: "relative",
          pointerEvents: 'auto'
        }}>
          <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${index}`}>Is Reviewed</Tooltip>}>
            <Label sx={{ cursor: "pointer", width: "auto", flexDirection: 'column', marginBottom: "15px" }}>
              <MdRateReview className="mx-1" style={{ color: "rgb(202 138 4)" }} />
              <Checkbox
                name={`${keys?.third}${index}`}
                id={`${keys?.third}${index}`}
                checked={isCheckedThird}
                onChange={handleThirdChange}
                style={{ cursor: "pointer" }}
              />
            </Label>
          </OverlayTrigger>

          <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${index}`}>Is done</Tooltip>}>
            <Label sx={{ cursor: "pointer", width: "auto", flexDirection: 'column', marginBottom: "15px", }}>
              <MdDownloadDone className="mx-1 text-success" />
              <Checkbox
                name={`${keys?.first}${index}`}
                id={`${keys?.first}${index}`}
                checked={isCheckedFirst}
                onChange={handleFirstChange}
                style={{ cursor: "pointer" }}
              />
            </Label>
          </OverlayTrigger>

          {parentName && (
            <Text className="textWrap_" style={{ marginRight: "11px" }}>
              ({displayName + (parentData?.payload?.number ? " " + parentData?.payload?.number : "")})
            </Text>
          )}
          <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${index}`}>{updateName}</Tooltip>}>
            <Input
              variant="PersonalDetailsInput"
              className="form-control"
              id={`checkList${index}`}
              sx={{
                '&:disabled ': {
                  backgroundColor: "transparent",
                }, backgroundColor: "transparent", borderColor: "transparent !important"
              }}
              value={updateName}
              onChange={(e) => setUpdateName(e.target.value)}
              onBlur={() => {
                editActionHighlightName();
                setIsEditing(true);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  editActionHighlightName();
                  setIsEditing(true);
                }
              }}
            />
          </OverlayTrigger>
          <Flex sx={{ marginLeft: "auto", gap: "1rem" }}>
            <Label htmlFor={`checkList${index}`} sx={{ cursor: "pointer" }} onClick={() => setIsEditing(false)}>
              {colorMode === 'light' ? <img src={editIcon} alt="edit" /> : <LuPenLine style={{ cursor: 'pointer', width: '24px', height: '24px', color: 'white' }} />}
            </Label>
            {isOthersTab && (
              <Text sx={{ cursor: "pointer" }} onClick={() => {
                setIsDeleteModelOpen(true);
                setDeleteData(action?._id);
              }}>
                <img src={deleteIcon} alt="delete" width={"23px"} />
              </Text>
            )}
          </Flex>
          {isShowDeleteCheckbox && (
            <Flex sx={{ cursor: 'pointer', flexDirection: "column", alignItems: "center", mb: 3, ml: 4 }}>
              <Label sx={{ cursor: "pointer", marginRight: '3px' }} >
                <MdDeleteForever size={23} color='#D70040' />
              </Label>
              <input type="checkbox"
                name={`delete${index}`}
                id={`delete${index}`}
                checked={deleteIdList?.includes(action?._id) || false}
                style={{ cursor: 'pointer' }}
                onChange={(e) => handleDeleteCheckboxChange(index, e.target.checked, action?._id, action)}
              />
            </Flex>
          )}

          {(isCheckedFirst && isCheckedThird) && <Box sx={{ position: "absolute", inset: 0, height: "1px", background: "#000", top: "50%" }}></Box>}
        </Flex>
      </Flex >

      <DeletePopModule setIsDeleteModelOpen={setIsDeleteModelOpen} updatedDataFun={deleteCheckAction} isDeleteModelOpen={isDeleteModelOpen} message={`Are you sure you want to delete this `} />

    </Box >
  )
}
